import { Outlet } from 'react-router-dom'

import { LanguageSwitcher } from '../components/LanguageSwitcher'

export default function PublicLayout() {
  return (
    <div className='bg-background text-foreground min-h-screen'>
      <main className='flex flex-col items-center justify-center'>
        <Outlet />
      </main>
      <div className='fixed top-4 right-4 z-50'>
        <LanguageSwitcher />
      </div>
    </div>
  )
}
